/**
 * This file originated from:
 * File: app/assets/javascripts/src-zugz/search/searchEvents.js
 * In commit: 6fba2b906e6b84c9bd2e3e2766aaf825c82f4f78
 * For ticket: GRINS-1507
 */

// fdRequire baggage: If you are in this file, please delete the next line and tidy up exports.
const module = { name: 'desktop/search/events', exports: {} };
const exports = module.exports;



import $ from '@take-2/fd-modules/jQuery';



const Selectors = {
    GLOBAL_SEARCH_INPUT: '#global-search-input-secondary',
    HTML_BODY: 'html,body',
    SEARCH_SECONDARY: '#search-secondary',
    SEARCH_LEGEND_NAV: '#search-legend-nav',
    SEARCH_LEGEND_NAV_BTN: '.js-search-nav-button',
    SEARCH_LINK_GO: '#search-link-go',
    GLOBAL_HEADER: '#global-header',
    SCROLL_TO_TOP: '#scroll-to-top',
}


const Styles = {
    HIDE: 'hide'
}
function onSearchNavClick(e) {
    e.preventDefault();
    if (!$(this).data('section')) {
        return;
    }
    const $el = $(`#${this.dataset.section}`);
    const hashOffsetTop = $el.offset().top;
    const documentWindowHeightDiff = $(document).height() - $(window).height();
    const dest = (hashOffsetTop > documentWindowHeightDiff) ? documentWindowHeightDiff : hashOffsetTop;
    $(Selectors.HTML_BODY).animate({ scrollTop: dest - 140 }, 1250, 'swing', () => {
        const $firstLink = $el.find('a');
        $firstLink.length && $($firstLink[0]).focus();
    });
}
function onSearchGoClick(e) {
    e.preventDefault();
    const $globalSearchInput = $(Selectors.GLOBAL_SEARCH_INPUT);
    let searchText = $globalSearchInput.val();
    if (searchText.trim() === '') {
        $globalSearchInput.val('');
    }
    else {
        searchText = encodeURIComponent(searchText);
        let pathname = window.location.href;
        const index = pathname.indexOf('?');
        if (index >= 0) {
            pathname = pathname.substring(0, index);
        }
        window.location = pathname + '?q=' + searchText;
    }
}
function isItemInView($el) {
    const offset = $el.offset();
    if (!offset || !offset.top) {
        return false;
    }
    const top = offset.top + $el.height() - $(window).scrollTop();
    const headerBottom = $(Selectors.GLOBAL_HEADER).height();
    return top > headerBottom;
}
function onScrollClick() {
    $(Selectors.HTML_BODY).animate({ scrollTop: 0 }, 1250, 'swing');
}
function onScroll() {
    $(Selectors.SCROLL_TO_TOP).toggleClass(Styles.HIDE, isItemInView($(Selectors.SEARCH_LEGEND_NAV)));
}
function attach() {
    $(document).on('scroll', onScroll);
    $(window).on('scroll', onScroll);
    $(Selectors.SCROLL_TO_TOP).on('click', onScrollClick);
    $(Selectors.SEARCH_SECONDARY).on('submit', onSearchGoClick);
    $(Selectors.SEARCH_LEGEND_NAV_BTN).on('click', onSearchNavClick);
}
export default {
    attach
};
